let interval = setInterval(function () {
  let labelTooltips = document.querySelectorAll('#avpoptions-container__v2 .ap-label-tooltip')
  if(labelTooltips) {
    for(let labelTooltip of labelTooltips) {
      let typeIconHoverTooltip = labelTooltip.lastChild.tagName
      if(typeIconHoverTooltip === 'DIV') {
        let lengthLabelTooltip = labelTooltip.offsetWidth 
      	let lengthIconHoverTooltip = labelTooltip.lastChild.offsetLeft
        let elementTooltip = labelTooltip.lastChild.lastChild
        
        if(lengthIconHoverTooltip >= lengthLabelTooltip/2) {
          elementTooltip.style.transform = 'translateX(-85%)';
          elementTooltip.style.left = '45px';
        } else {
          elementTooltip.style.transform = 'unset';
          elementTooltip.style.left = 'unset';
          
        }
      }
    }
  }
}, 100)